// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"Gfad451","ctaInnerContainer":"G49980f","ctaText":"Gf9f513","ctaButton":"Ga86b9b","ctaAllRecipe":"G31e151","spottyBorder":"G45c65f"};